exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".web-chat-group {\n  border-radius: 0;\n  width: 100%;\n  max-height: 100px;\n  background-color: #fff;\n}\n#container {\n  margin-bottom: -20px;\n}\n@media screen and (max-width: 991px) {\n#container {\n    flex-direction: column;\n    align-items: center;\n}\n}\n", ""]);

// exports
